module.exports = __webpack_public_path__ + "static/media/CSPORT TAT1M2 TURNTABLE.87e15b60.png";